import { KW_GRADIENT } from './theme'

/**
 * The K-Assist mark: a bold K (Kawaconn) with a sparkle (AI) at its top right. Drawn in
 * currentColor, so it is white on the avatar and teal in the Quick Action menu.
 */
export const KAssistMark = ({
  size = 15,
  className,
}: {
  size?: number
  className?: string
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={className}
    aria-hidden="true"
  >
    <g transform="translate(-1.4 .6)">
      <rect
        x="5.5"
        y="5"
        width="3.2"
        height="14"
        rx="1.6"
        fill="currentColor"
      />
      <path
        d="M9.6 12 13.8 7.2M10.2 11.3l5.3 7.1"
        stroke="currentColor"
        strokeWidth="3.2"
        strokeLinecap="round"
        fill="none"
      />
      <path
        fill="currentColor"
        d="M19 1.6c.22 1.9 1 2.9 2.9 3.1-1.9.22-2.68 1.2-2.9 3.1-.22-1.9-1-2.88-2.9-3.1 1.9-.2 2.68-1.2 2.9-3.1z"
      />
    </g>
  </svg>
)

/** Gradient K-Assist avatar — the assistant's visual identity. */
const AssistantAvatar = ({ size = 28 }: { size?: number }) => (
  <div
    className="flex flex-shrink-0 items-center justify-center rounded-full"
    style={{
      width: size,
      height: size,
      color: '#fff',
      background: KW_GRADIENT,
      boxShadow: '0 2px 6px rgba(31,192,218,.35)',
    }}
  >
    <KAssistMark size={Math.round(size * 0.6)} />
  </div>
)

export default AssistantAvatar
